
import { firstValueFrom } from 'rxjs'
import { createAppAsyncThunk } from 'store/state'
import { V1 } from './net'

export * from './getFailed'
export * from './getPlanned'
export * from './getPosted'

export const getPostsCount = createAppAsyncThunk(
  'posts/getPostsCount',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getPostsCount()))
      return response
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)
